import formatFileSize from 'src/utils/formatFileSize';
import type { FileUploaderProps } from './FileUploader';
import getHumanReadableStringOfAcceptedMimeTypes from './getHumanReadableStringOfAcceptedMimeTypes';

/**
 * @access package
 *
 * FIXME (FED-4073) intl all these strings
 */
export function buildFileUploaderDescriptionText(
  props: Pick<
    FileUploaderProps,
    | 'descriptionText'
    | 'acceptedMimeTypes'
    | 'maxNumberOfFiles'
    | 'maxSizeInBytes'
  >
): string {
  const {
    descriptionText: descriptionTextProp,
    acceptedMimeTypes = {},
    maxNumberOfFiles = 0,
    maxSizeInBytes,
  } = props;

  if (descriptionTextProp) return descriptionTextProp;
  const descriptionParts: string[] = [
    ...(maxNumberOfFiles !== 0
      ? [
          `Upload ${
            maxNumberOfFiles > 1 ? `up to ${maxNumberOfFiles} files` : '1 file'
          }.`,
        ]
      : []),
    ...(Object.keys(acceptedMimeTypes).length > 0
      ? [
          `Accepted formats: ${getHumanReadableStringOfAcceptedMimeTypes(
            acceptedMimeTypes
          )}.`,
        ]
      : []),
    ...(maxSizeInBytes
      ? [`Maximum size: ${formatFileSize(maxSizeInBytes)}.`]
      : []),
  ];

  return descriptionParts.join(' ');
}

export default buildFileUploaderDescriptionText;
